import { COLLAB_TRIGGER_TYPES, type CollabTriggerType } from "@unbox/api";
import { useFeatureFlag } from "@/hooks/use-feature-flag";

const FLAGGED_COLLAB_TRIGGER_TYPES: CollabTriggerType[] = ["first_collab_video"];

const BASE_COLLAB_TRIGGER_TYPES = COLLAB_TRIGGER_TYPES.filter((t) => !FLAGGED_COLLAB_TRIGGER_TYPES.includes(t));

export function useCollabTriggerTypes(): readonly CollabTriggerType[] {
  const milestoneTriggersEnabled = useFeatureFlag("F-automation-milestone-triggers");
  return milestoneTriggersEnabled ? COLLAB_TRIGGER_TYPES : BASE_COLLAB_TRIGGER_TYPES;
}
